
<h3 style="text-align:center;color:blue;cursor:pointer; margin-top:10%; margin-bottom:10%">You are being forwarded to your course.  Please wait...</h3>



<!-- <a (click)="LogUserIntoMatrixAndGoToCourse()">
    <h3 style="text-align:center;color:blue;cursor:pointer; margin-top:50px; margin-bottom:50px">Demo - SSO with a
      MyHarrells user and Matrix</h3>
    <h5 style="text-align:center;color:blue;cursor:pointer; margin-top:50px; margin-bottom:50px">Testing with
      accounting&#64;canoaranchgolfclub.com</h5>
  </a>
  <div style="text-align:center;">
    <h6 style="margin-bottom: 50px;">If the Matrix account is not set up this will create the account as a Learner, enroll them in the class if not already enrolled, forward the user to the Matrix site and log them in. If the Matrix account exists it will just enroll them in the class if not enrolled, forward the user and
      log them in.
    </h6>
  </div> -->
  
  <!-- MATRIX LOGIN FORM THAT WE POPULATE AND SUBMIT BEHIND THE SCENES FOR A SSO EXPERIENCE -->
  <!-- this will always stay hidden from the user -->
  <div id="lms_widget_container" style="position:fixed; top: -500px; left:-500px">
    <div id="lms_widget_header">
      <h1>Online School</h1>
    </div>
  
    <div id="lms_widget_inner">
  
  
      <form name="form1" method="post" action="https://harrells.matrixlms.com/log_in/submit" target="_blank">
        <label for="userid">User ID</label>
        <input type="text" name="userid" id="userid" class="lms_widget_border">
  
        <label for="password">Password</label>
        <a href="http://harrells.matrixlms.com/log_in/forgot_password" target="_blank">(forgot?)</a><br>
        <input type="password" name="password" id="password" class="lms_widget_border"><br>
  
        <button type="submit" id="submitButton" value="Submit">Log in</button>
  
        <input type="checkbox" name="remember" id="remember">
        <label for="remember">Remember me?</label>
      </form>
    </div>
  </div>
  <!-- this will always stay hidden from tue user  -->